import React from "react";
import Footer from "../assets/components/sections/Footer";
import TopBanner from "../assets/components/parts/TopBanner";
import { useTranslation } from "react-i18next";
import banner_img from "../assets/images/entrancebelow.jpg";
function Home() {
  const { t } = useTranslation();
  return <>
  <TopBanner title={t("banner.press")} background={banner_img}/>
  <Footer/>
  </>;
}

export default Home;
